const htmlToPlainText = (html: string) => {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '');
};

export default htmlToPlainText;
